export function normalizeToBoolean(value: any) {
  // If it's already a boolean, return it as is
  if (typeof value === 'boolean') {
    return value;
  }

  // If it's a string, check if it equals 'true' (case insensitive)
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true';
  }

  return false;
}
